<div class="page">
  <ngx-loading [show]="showSpinner"></ngx-loading>

  <div class="page-content">
    <div class="table-top">
      <div class="section-header">Firmas pendientes</div>
    </div>

    <!-- SECCIÓN SUPERIOR: configuración de alertas -->
    <div class="card mt-3">
      <div class="card-body">

        <div class="alert alert-success" *ngIf="successMessage">{{ successMessage }}</div>
        <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>

        <!-- Toggle con badge de estado dinámico -->
        <div class="d-flex align-items-center mb-3">
          <div class="custom-control custom-switch">
            <input
              type="checkbox"
              class="custom-control-input"
              id="isEnabled"
              [(ngModel)]="config.isEnabled"
            />
            <label class="custom-control-label" for="isEnabled">
              Alertas por firma pendiente
            </label>
          </div>
          <span class="badge ml-2" [ngClass]="config.isEnabled ? 'badge-success' : 'badge-danger'">
            {{ config.isEnabled ? 'Habilitado' : 'Deshabilitado' }}
          </span>
        </div>

        <!-- Campos en fila horizontal con divider y botón Guardar a la derecha -->
        <div class="d-flex align-items-start">

          <!-- Umbral de alerta -->
          <div>
            <label class="font-weight-bold small text-uppercase text-muted d-block mb-1">Umbral de alerta</label>
            <div class="d-flex" style="gap: 6px;">
              <input
                type="number"
                class="form-control"
                style="width: 90px;"
                [(ngModel)]="thresholdValue"
                min="1"
                [class.is-invalid]="isThresholdInvalid"
              />
              <select class="form-control" style="width: auto;" [(ngModel)]="thresholdUnit">
                <option>Horas</option>
                <option>Días</option>
                <option>Minutos</option>
              </select>
            </div>
            <small class="form-text text-muted">Tiempo desde la solicitud de firma antes de notificar.</small>
            <div class="text-danger small mt-1" *ngIf="isThresholdInvalid">El valor debe ser mayor a 0.</div>
          </div>

          <!-- Divider vertical -->
          <div style="width: 1px; background: #dee2e6; align-self: stretch; margin: 0 20px;"></div>

          <!-- Frecuencia del job -->
          <div>
            <label class="font-weight-bold small text-uppercase text-muted d-block mb-1">Frecuencia del job</label>
            <div class="d-flex" style="gap: 6px;">
              <input
                type="number"
                class="form-control"
                style="width: 90px;"
                [(ngModel)]="frequencyValue"
                min="1"
                [class.is-invalid]="isFrequencyInvalid"
              />
              <select class="form-control" style="width: auto;" [(ngModel)]="frequencyUnit">
                <option>Minutos</option>
                <option>Horas</option>
              </select>
            </div>
            <small class="form-text text-muted">Intervalo entre ciclos del job.</small>
            <div class="text-danger small mt-1" *ngIf="isFrequencyInvalid">El valor debe ser mayor a 0.</div>
          </div>

          <!-- Botón Guardar alineado a la derecha y abajo -->
          <div class="ml-auto align-self-end">
            <button class="btn btn-primary" (click)="save()" [disabled]="showSpinner || !isFormValid">
              <i class="fa fa-save"></i> Guardar
            </button>
          </div>

        </div>
      </div>
    </div>

    <!-- SECCIÓN INFERIOR: lista de firmas pendientes -->
    <div class="card mt-3">
      <div class="card-body p-0">

        <div *ngIf="pendingLoading" class="p-3 text-center text-muted">
          <i class="fa fa-spinner fa-spin"></i> Cargando...
        </div>

        <div class="alert alert-danger m-3" *ngIf="pendingError">{{ pendingError }}</div>

        <div
          *ngIf="!pendingLoading && pendingItems.length === 0 && !pendingError"
          class="alert alert-info m-3">
          No hay constancias con firma pendiente que superen el umbral configurado.
        </div>

        <table class="table table-bordered mb-0" *ngIf="!pendingLoading && pendingItems.length > 0">
          <thead>
            <tr class="table-names">
              <th>ID Constancia</th>
              <th>Tipo</th>
              <th>Firmante(s)</th>
              <th>Email</th>
              <th>Tiempo pendiente</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of pendingItems">
              <tr *ngFor="let user of item.usersWithPendingSignature; let first = first">
                <td *ngIf="first" [attr.rowspan]="item.usersWithPendingSignature.length">
                  {{ item.documentProcessId }}
                </td>
                <td *ngIf="first" [attr.rowspan]="item.usersWithPendingSignature.length">
                  {{ item.constancyType }}
                </td>
                <td>{{ user.name }}</td>
                <td>{{ user.email }}</td>
                <td>
                  <span class="badge badge-warning">
                    <i class="fa fa-clock-o" aria-hidden="true"></i>
                    {{ formatMinutes(user.minutesSinceRequest) }}
                  </span>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>

      </div>
    </div>

  </div>
</div>
